/* global Forms */

window['application#ui'] = function () {
  Forms.initPasswordChecker()
}
